var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "3",
            name: "entry_date",
            label: _vm._f("pgettext")("Date", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormDatetime", {
            attrs: {
              name: "entry_date",
              readonly: _vm.item.isReadonly,
              required: ""
            },
            model: {
              value: _vm.item.entry_date,
              callback: function($$v) {
                _vm.$set(_vm.item, "entry_date", $$v)
              },
              expression: "item.entry_date"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "document_type",
            label: _vm._f("pgettext")("Document type", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            contentClass: "form-row",
            required: ""
          }
        },
        [
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("ItpFormSelect", {
                attrs: {
                  name: "direction",
                  options: _vm.directions,
                  valueField: "value",
                  textField: "text",
                  readonly: _vm.item.isReadonly
                },
                model: {
                  value: _vm.item.direction,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "direction", $$v)
                  },
                  expression: "item.direction"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("ItpFormSelect", {
                attrs: {
                  name: "document_type",
                  options: _vm.documentTypes,
                  valueField: "value",
                  textField: "text",
                  disabled: _vm.item.isReadonly
                },
                on: {
                  input: function($event) {
                    return _vm.evh_1468474219929533_input($event, {})
                  }
                },
                model: {
                  value: _vm.item.document_type,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "document_type", $$v)
                  },
                  expression: "item.document_type"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "subject",
            label: _vm._f("pgettext")("Subject", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormInput", {
            attrs: {
              name: "subject",
              required: "",
              autofocus: "",
              disabled: _vm.item.isReadonly
            },
            model: {
              value: _vm.item.subject,
              callback: function($$v) {
                _vm.$set(_vm.item, "subject", $$v)
              },
              expression: "item.subject"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "reference_number",
            label: _vm._f("pgettext")("Reference number", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "The invoice number, contract number or other number identifying the registered document.",
              "RegisterEntry|Help|Reference number"
            )
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "reference_number", readonly: _vm.item.isReadonly },
            on: {
              input: function($event) {
                return _vm.evh_6917646200545441_input($event, {})
              }
            },
            model: {
              value: _vm.item.reference_number,
              callback: function($$v) {
                _vm.$set(_vm.item, "reference_number", $$v)
              },
              expression: "item.reference_number"
            }
          }),
          _vm._v(" "),
          _vm.invoiceCheckResult &&
          _vm.invoiceCheckResult.register_entry == null
            ? _c(
                "div",
                { staticClass: "alert alert-in-form alert-primary" },
                [
                  _vm.invoiceCheckResult.register_entry == null
                    ? _c("ItpIcon", { attrs: { fa: "info-circle" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("pgettext")(
                            "An invoice exists with the given number. Click to assign it to the current entry.",
                            "RegisterEntry"
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ItpLink", {
                    staticClass: "d-inline-block",
                    attrs: {
                      text: _vm._f("pgettext")(
                        "Assign invoice",
                        "RegisterEntry"
                      )
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_6941071772471093_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.invoiceCheckResult &&
          _vm.invoiceCheckResult.register_entry != null
            ? _c(
                "div",
                { staticClass: "alert alert-in-form alert-warning" },
                [
                  _c("ItpIcon", { attrs: { fa: "exclamation-circle" } }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("pgettext")(
                            "An invoice exists with the given number but it's already registered.",
                            "RegisterEntry"
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("UcRegisterEntryMiniCard", {
                    attrs: {
                      item: _vm.invoiceCheckResult.register_entry,
                      "no-icon": ""
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "6",
            name: "clerk",
            label: _vm._f("pgettext")("Clerk", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "New values entered are memorized and saved to the database.",
              "RegisterEntry|Help|Clerk"
            )
          }
        },
        [
          _c("ItpFormSelect2", {
            attrs: {
              name: "clerk",
              taggable: "",
              options: _vm.clerks,
              readonly: _vm.item.isReadonly,
              valueField: "name",
              textField: "name"
            },
            model: {
              value: _vm.item.clerk,
              callback: function($$v) {
                _vm.$set(_vm.item, "clerk", $$v)
              },
              expression: "item.clerk"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "client",
            labelAlign: _vm.labelAlign,
            label: _vm._f("pgettext")("Partner", "RegisterEntry"),
            helpTooltip: _vm._f("pgettext")(
              "Search and select a company or enter it's name if the database does not contain its data. Type ENTER after typing in a new value.",
              "RegisterEntry|Help|Partner"
            )
          }
        },
        [_c("UcRegisterEntryPartnerSelector", { attrs: { editor: _vm.item } })],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.item.document_type == "invoice"
        ? _c(
            "ItpFormGroup",
            {
              attrs: {
                labelColsMd: "3",
                contentColsMd: "9",
                name: "invoice",
                label: _vm._f("pgettext")("Invoice", "RegisterEntry"),
                labelAlign: _vm.labelAlign
              }
            },
            [
              _c("UcRegisterEntryInvoiceSelector", {
                attrs: { editor: _vm.item }
              }),
              _vm._v(" "),
              _vm.item.id &&
              (!_vm.item.invoice || !_vm.item.invoice.id) &&
              _vm.item.reference_number
                ? _c("ItpButton", {
                    staticClass: "mt-2",
                    attrs: {
                      text: _vm._f("pgettext")(
                        "Create invoice...",
                        "RegisterEntry"
                      ),
                      size: "sm",
                      variant: "primary",
                      tooltip: _vm._f("pgettext")(
                        "Create invoice with the given reference number.",
                        "RegisterEntry"
                      ),
                      icon: _vm.$config.addIcon
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_7463771596263925_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "ref_entry",
            label: _vm._f("pgettext")("Reference entry", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            labelColsMd: "3",
            contentColsMd: "9",
            helpTooltip: _vm._f("pgettext")(
              "Reference of an other entry in any version of the current register.",
              "RegisterEntry|Help|Clerk"
            )
          }
        },
        [
          _c("ItpFormSelect2", {
            attrs: {
              name: "ref_entry",
              dataSource: _vm.b_8680084583475136_dataSource,
              initialOptions: _vm.item.ref_entry ? [_vm.item.ref_entry] : [],
              valueField: "id",
              clearable: "",
              "bind-object": "",
              optionTemplate:
                "<UcSuggestRegisterEntryOption :option=option></UcSuggestRegisterEntryOption>",
              "use-option-template-for-selected-option": "",
              readonly: _vm.item.isReadonly
            },
            on: {
              optionSelected: function($event) {
                return _vm.evh_8680084583475136_optionSelected($event, {})
              }
            },
            model: {
              value: _vm.item.ref_entry,
              callback: function($$v) {
                _vm.$set(_vm.item, "ref_entry", $$v)
              },
              expression: "item.ref_entry"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "5",
            name: "status",
            label: _vm._f("pgettext")("Status", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "Type in arbitrary values to assign a status. The values are memorized. Press ENTER after typing in a new value.",
              "RegisterEntry|Help|Status"
            )
          }
        },
        [
          _c("ItpFormSelect2", {
            attrs: {
              name: "status",
              taggable: "",
              options: _vm.statuses,
              readonly: _vm.item.isReadonly,
              valueField: "name",
              textField: "name"
            },
            model: {
              value: _vm.item.status,
              callback: function($$v) {
                _vm.$set(_vm.item, "status", $$v)
              },
              expression: "item.status"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "categories",
            label: _vm._f("pgettext")("Categories", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "Assign multiple arbitrary values. The values are memorized. Press ENTER after typing in a new value.",
              "RegisterEntry|Help|Categories"
            )
          }
        },
        [
          _c("ItpFormSelect2", {
            attrs: {
              name: "categories",
              multiple: "",
              taggable: "",
              options: _vm.categories,
              readonly: _vm.item.isReadonly,
              valueField: "name",
              textField: "name"
            },
            model: {
              value: _vm.item.categories,
              callback: function($$v) {
                _vm.$set(_vm.item, "categories", $$v)
              },
              expression: "item.categories"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "project",
            label: _vm._f("pgettext")("Project", "RegisterEntry"),
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("UcProjectSelector", {
            attrs: { item: _vm.item, name: "project" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "3",
            name: "delivery_date",
            label: _vm._f("pgettext")("Delivery date", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "Receive or delivery date.",
              "RegisterEntry|Help|Delivery date"
            )
          }
        },
        [
          _c("ItpFormDatetime", {
            attrs: { name: "delivery_date", readonly: _vm.item.isReadonly },
            model: {
              value: _vm.item.delivery_date,
              callback: function($$v) {
                _vm.$set(_vm.item, "delivery_date", $$v)
              },
              expression: "item.delivery_date"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "5",
            name: "delivery_date",
            label: _vm._f("pgettext")("Delivery modes", "RegisterEntry"),
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormSelect2", {
            attrs: {
              name: "delivery_modes",
              options: _vm.deliveryModes,
              valueField: "name",
              textField: "name",
              multiple: ""
            },
            model: {
              value: _vm.item.delivery_modes,
              callback: function($$v) {
                _vm.$set(_vm.item, "delivery_modes", $$v)
              },
              expression: "item.delivery_modes"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "3",
            name: "due_date",
            label: _vm._f("pgettext")("Due date", "RegisterEntry"),
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormDatetime", {
            attrs: { name: "due_date", readonly: _vm.item.isReadonly },
            model: {
              value: _vm.item.due_date,
              callback: function($$v) {
                _vm.$set(_vm.item, "due_date", $$v)
              },
              expression: "item.due_date"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "3",
            name: "priority",
            label: _vm._f("pgettext")("Priority", "RegisterEntry"),
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormSelect", {
            attrs: {
              name: "priority",
              options: _vm.priorities,
              readonly: _vm.item.isReadonly
            },
            model: {
              value: _vm.item.priority,
              callback: function($$v) {
                _vm.$set(_vm.item, "priority", $$v)
              },
              expression: "item.priority"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "5",
            name: "storage_location",
            label: _vm._f("pgettext")("Storage location", "RegisterEntry"),
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "The description or number of the document's storage location.",
              "RegisterEntry|Help|Storage location"
            )
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "storage_location", readonly: _vm.item.isReadonly },
            model: {
              value: _vm.item.storage_location,
              callback: function($$v) {
                _vm.$set(_vm.item, "storage_location", $$v)
              },
              expression: "item.storage_location"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "8",
            name: "notes",
            label: _vm._f("pgettext")("Notes", "RegisterEntry"),
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormTextarea", {
            attrs: { name: "notes", readonly: _vm.item.isReadonly },
            model: {
              value: _vm.item.notes,
              callback: function($$v) {
                _vm.$set(_vm.item, "notes", $$v)
              },
              expression: "item.notes"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.item.id ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _vm.item.id
        ? _c("UcAttachmentsList", { attrs: { parent: _vm.item } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }